import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Text } from '@uhg-abyss/web/ui/Text';
import { useTranslation } from 'react-i18next';

const ShareButtonStyled = styled(Button, {
  variants: {
    view: {
      mobile: {
        '&.abyss-button-root': {
          width: '110px',
          color: 'gray6',
        },
      },
      desktop: {
        '&.abyss-button-root': {
          paddingRight: 0,
        },
      },
      none: {
        display: 'none',
      },
    },
  },
});

type Props = {
  view: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

export const ShareButton = ({ view, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <ShareButtonStyled
      data-auto-testid="mapview-share-button"
      data-testid="mapview-share-button"
      onClick={onClick}
      variant="text"
      view={view}
    >
      <IconSymbol
        css={{
          'abyss-icon': {
            marginRight: '$xs',
          },
        }}
        icon="share"
      />
      <Text color="$core.color.neutral.80" fontSize="md" fontWeight="medium">
        {t('Share')}
      </Text>
    </ShareButtonStyled>
  );
};
